import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, HostListener, ViewChild, ElementRef } from '@angular/core';
import { AvailabilityService } from 'src/app/services/jrni/availability.service';
import { AlertService } from 'src/app/_alert';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { DatastoreService } from 'src/app/services/datastore.service';
import { interval } from 'rxjs';

@Component({
  selector: 'app-mat-calendar',
  templateUrl: './mat-calendar.component.html',
  styleUrls: ['./mat-calendar.component.scss']
})
export class MatCalendarComponent implements OnInit {
  minDate;
  maxDate;
  startDate;
  selectedDate: Date;
  currentDate: Date;
  slots: any[] = [];
  tempSlots: any[] = [];
  selectedSlot;
  endTime;
  slotDuration;

  subscription;
  availableDays: any;
  @Input() service: any;
  @Input() location: any;
  @Input() component: any;
  @Output() selectSlotUpdate = new EventEmitter<boolean>();
  @Output() spinStop = new EventEmitter<boolean>();
  @ViewChild('calendar') calendar: any;

  constructor(
    private availabilityService: AvailabilityService,
    private alertService: AlertService,
    private translateService: TranslateService,
    private spinner: NgxSpinnerService,
    private datastoreService: DatastoreService,
    private ElByClassName: ElementRef
  ) { }

  ngOnInit() {
    this.spinner.show();
    // Set the current date to today for the calendar to default to today
    this.currentDate = new Date();
    this.selectedDate = this.currentDate;

    // Set max date as yesterday so the user cannot select a date until
    this.minDate = new Date(this.service.min_advance_datetime);
    this.maxDate = new Date(this.service.max_advance_datetime);

    this.slotDuration = this.service.booking_time_step;

    console.log(this.minDate);
    console.log(this.maxDate);

    this.newCalendarRun(undefined);
  }

  async newCalendarRun(date) {
    this.spinner.show();
    // get the start time of the month selected
    const dateRange = this.getDateRange(date);
    const params = {
      'service_id': this.service.id,
      'start_date': dateRange.startDate,
      'end_date': dateRange.endDate
    };
    this.spinner.show();
    this.availabilityService.getSlots(this.location, params).then(async (res: any) => {

      let days = [];
      this.tempSlots = [];
      res.times.forEach((timeslot) => {
        if (timeslot.available) {
          this.tempSlots.push(timeslot);
        }
      });

      // work out days from the tempSlots
      this.tempSlots.forEach((slot) => {
        let formatedDate = moment(slot.start).format('YYYY-MM-DD');
        let found = days.find(daysDate => daysDate.date == formatedDate);
        if (found) {
          found.spaces = found.spaces + 1;
        } else {
          days.push({ spaces: 0, date: formatedDate });
        }
      });

      await this.availabilityService.setAvailableDays(days);

      this.availableDays = days;

      if (days && days.length > 0) {
        this.newUpdateSlots(new Date(days[0].date));
      } else {
        this.newUpdateSlots(new Date());
      }
    });
  }

  async newUpdateSlots(date) {
    this.slots = [];
    // Update the selected date
    this.selectedDate = date;

    this.slots = this.tempSlots.filter(slot => {
      let slotDate = moment(slot.start).format('YYYY-MM-DD');
      let selectedDate = moment(date).format('YYYY-MM-DD');
      if (slotDate == selectedDate) {
        return slot;
      }
    });

    // Sort from earliest to latest time
    this.slots.sort((a, b) => a.time - b.time);
    this.spinStop.emit(true)
    this.spinner.hide();
  };

  // Check if the date is unavailable and if so return false
  unavailableDates = (date: Date): boolean => {
    const momentDate = moment(date);
    if (this.availableDays) {
      return this.availableDays.some(day => momentDate.isSame(day.date));
    } else {
      return false;
    }
  }

  @HostListener('click', ['$event'])
  onClick(event: any) {
    // get the clicked element
    if (event.target.ariaLabel && event.target.ariaLabel.includes("Previous month") || event.target.ariaLabel && event.target.ariaLabel.includes("Next month")) {
      this.spinner.show();
      let startOfMonth = moment(this.calendar.monthView._activeDate).startOf('month').format('YYYY-MM-DD');
      this.slots = [];
      this.tempSlots = [];
      this.startDate = startOfMonth;
      this.availableDays = undefined;
      this.newCalendarRun(startOfMonth);
    }
  }

  ngAfterViewInit() {
    const source = interval(500); // repetedly check to see if we need to add avaiable/unavaiable to the aria (which is sued by screen readers)
    const text = 'Your Text Here';
    this.subscription = source.subscribe(val => {
      let dateElement: any = (<HTMLElement>this.ElByClassName.nativeElement).querySelectorAll(
        '.mat-calendar-body-cell'
      );
      for (let i = 0; i < dateElement.length; i++) {
        const old = dateElement[i].ariaLabel;
        if (old !== old.replace(" unavailable", "").replace(" available", "")) {
          ;// allready up to date so dont do it all over again again
          return;
        }
        dateElement[i].ariaLabel = old.replace(" unavailable", "").replace(" available", "") + ' available';
        dateElement[i].removeAttribute("aria-selected")
        dateElement[i].removeAttribute("role")
      }
      dateElement = (<HTMLElement>this.ElByClassName.nativeElement).querySelectorAll(
        '.mat-calendar-body-disabled'
      );
      for (let i = 0; i < dateElement.length; i++) {
        const old = dateElement[i].ariaLabel;

        dateElement[i].ariaLabel = old.replace(" unavailable", "").replace(" available", "") + ' unavailable';
      }
    });
  }


  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // Set the slot
  selectSlot(slot) {
    slot.datetime = moment(slot.start).format("YYYY-MM-DDTHH:mm:ss");
    this.selectedSlot = slot;
    this.availabilityService.setSelectedSlot(slot);
    this.selectSlotUpdate.emit(true);
    // set end slot time
    var endSlot = slot.datetime
    this.endTime = moment(endSlot).add(this.slotDuration, 'm').toDate();
    this.availabilityService.setEndSlot(this.endTime)
  }

  getDateRange(date) {
    const startDate = moment(date).startOf('month').format('YYYY-MM-DD hh:mm');
    const endDate = moment(date).endOf('month').format('YYYY-MM-DD hh:mm');
    return {
      startDate,
      endDate
    };
  }
}
